module.exports = __webpack_public_path__ + "static/media/splash-image.e3d9932d.png";